import * as React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import {BonusProgressBarCSB} from '/component/base/BonusProgressBar';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './EarnedCSBPlusReportContent.style';
interface BonusHistoryItem {
  newOrderingEntityCount: number;
  earnedOn: string;
  earnedBonusAmount: number;
}
interface Props {
  recordData: {
    bonusHistory: BonusHistoryItem[];
  };
}

export const EarnedCSBPlusReportContent: React.FC<Props> = ({recordData}) => {
  const bonusHistory = get(recordData, 'bonusHistory', []);
  const {tt} = useTranslation('reportCardContent.earnedCSBPlus');

  return (
    <View style={styles.base}>
      <Gutter style={styles.header}>
        <Text variant="heading">
          {tt('title', 'Earned Client Support Bonus+')}
        </Text>
      </Gutter>
      {bonusHistory.map(
        ({newOrderingEntityCount, earnedOn, earnedBonusAmount}, index) => (
          <Gutter key={index} style={styles.bonusProgressBar}>
            <BonusProgressBarCSB
              newOrderingEntities={newOrderingEntityCount}
              currentDate={earnedOn}
              earnedBonusAmount={earnedBonusAmount}
              isEarnedBonusCard
            />
          </Gutter>
        ),
      )}
    </View>
  );
};
